import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
  Tooltip,
  Box,
} from "@mui/material";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { Coach } from "../types/Coach";

interface CoachesTableProps {
  coaches: Coach[];
  loading: boolean;
  onView: (coach: Coach) => void;
  onEdit: (coach: Coach) => void;
  onDelete: (coach: Coach) => void;
}

const CoachesTable: React.FC<CoachesTableProps> = ({
  coaches,
  loading,
  onView,
  onEdit,
  onDelete,
}) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <TableContainer
      component={Paper}
      sx={{ borderRadius: 2, overflow: "hidden" }}
    >
      <Table>
        <TableHead sx={{ backgroundColor: "#f8f9fa" }}>
          <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>Nom</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Téléphone</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Équipes</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Statut</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Date de création</TableCell>
            <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {coaches.map((coach, index) => (
            <TableRow
              key={coach._id}
              hover
              sx={{
                "&:nth-of-type(odd)": {
                  backgroundColor: "#fafafa",
                },
              }}
            >
              <TableCell sx={{ fontWeight: 500 }}>{coach.name}</TableCell>
              <TableCell>{coach.mail}</TableCell>
              <TableCell>{coach.number}</TableCell>
              <TableCell>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {coach.team ? (
                    <Chip
                      label={coach.team.shortName}
                      size="small"
                      variant="outlined"
                      color="primary"
                      title={coach.team.name}
                    />
                  ) : (
                    <Chip
                      label="Aucune équipe"
                      size="small"
                      variant="outlined"
                      color="default"
                    />
                  )}
                </Box>
              </TableCell>
              <TableCell>
                <Chip
                  label={coach.isActive ? "Actif" : "Inactif"}
                  color={coach.isActive ? "success" : "default"}
                  size="small"
                  variant="outlined"
                />
              </TableCell>
              <TableCell>{formatDate(coach.createdAt)}</TableCell>
              <TableCell>
                <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                  <Tooltip title="Voir les détails">
                    <IconButton
                      size="small"
                      onClick={() => onView(coach)}
                      sx={{ color: "primary.main" }}
                    >
                      <Visibility />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Modifier">
                    <IconButton
                      size="small"
                      onClick={() => onEdit(coach)}
                      sx={{ color: "warning.main" }}
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Supprimer">
                    <IconButton
                      size="small"
                      onClick={() => onDelete(coach)}
                      sx={{ color: "error.main" }}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CoachesTable;
